export async function updateOutForDelivery(prescriptionId, payload) {
  const res = await window.axios({
    method: 'POST',
    baseURL: process.env.VUE_APP_EPRES_ENDPOINT,
    url: `pharmacist/${prescriptionId}/outForDelivery`,
    data: payload,
  });

  return res;
}
